import { Inject, Injectable, PLATFORM_ID } from '@angular/core'
import { filter } from 'rxjs/operators'
import { Router, NavigationEnd } from '@angular/router'
import { environment } from '../../../environments/environment'
import { SharedDataService } from 'src/app/core/services/shared-data.service'
import { NGXLogger } from 'ngx-logger'
import { isPlatformBrowser } from '@angular/common'

@Injectable({
  providedIn: 'root'
})
export class PageService {
  equipmentProviderInActive: boolean
  cdn: string;
  // used from policies, out there for working footer links
  public showFaq = false
 constructor(
    public logger: NGXLogger,
    public sharedDataService: SharedDataService,
     @Inject(PLATFORM_ID) private platformId: object,
    public router: Router) { 
      this.equipmentProviderInActive = this.sharedDataService.getPortalType();
      if(this.equipmentProviderInActive){
        this.cdn = environment.API_EQUIP_PROVIDER_CDN_URL
      } else {
        this.cdn = environment.API_DENTAL_CDN_URL
      }
    }

  scrollToElement() {
    this.router.events
      .pipe(filter(e => e instanceof NavigationEnd))
      .subscribe((e: NavigationEnd) => {
        const navigation = this.router.getCurrentNavigation()
        const to: string = navigation.extras.state ? navigation.extras.state.to : ''
        this.scrollTo(to)
      }, (error: any) => {
        console.error(error)
      })
  }

  /**
   * Used for scroll with delay (if default router + scroll not working)
   * @param href e.g. '/policies'
   * @param target e.g. 'faq'
   */
  async goAndScroll(href: string, target: string) {
    await this.router.navigate([href])
    await this.scrollTo(target)
  }


  closeAccountModal(){
   if(this.router.url.indexOf('(modal') > -1){
    this.router.navigate([{ outlets: { modal: null }}])
   }
  }

  async scrollTo(to: string, blockValue?: 'start' | 'center' | 'end' | 'nearest', timeout?: number) {
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    this.closeAccountModal()
    if (!blockValue) {
      blockValue = 'start'
    }
    if (!timeout) {
      // timeout = 20
      timeout = 100
    }
    if (to !== '') {
      let foundSelector = document.getElementById(`${to}`)
      const ms = 150
      while (!foundSelector) {
        await new Promise(r => setTimeout(r, ms))
        foundSelector = document.getElementById(`${to}`)
      }
      this.logger.info(foundSelector)
      setTimeout(() => {
        if (blockValue === 'center') {
          foundSelector.scrollIntoView(true)
        }
        else {
          foundSelector.scrollIntoView({ block: blockValue, behavior: 'smooth' })
        }
      }, timeout)
    }
    else {
      this.logger.info('to is empty' + to)
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      })
    }
  }

  inputCasting(array: any[]): any {
    const obj = {}
    for (const component of array) {
      if (component?.name) {
        const objKey = component.name
        obj[objKey] = component
      }
    }
    return obj
  }

  getImageURL(path: string): string {
    if (path.startsWith('http')) {
      return path
    }
    return this.cdn + path
  }

  getVideoURL(mediaObject: any): string {
    if (!mediaObject?.url) { return '' }
    if (mediaObject.url.startsWith('http')) {
      return mediaObject.url
    }
    return this.cdn + mediaObject.url
  }

  imageMap(imageObj: any) {
    const arr = []
    if (imageObj?.formats?.small) {
      arr.push(`${this.getImageURL(imageObj.formats.small.url)} ${imageObj.formats.small.width}w`)
    }
    if (imageObj?.formats?.medium) {
      arr.push(`${this.getImageURL(imageObj.formats.medium.url)} ${imageObj.formats.medium.width}w`)
    }
    if (imageObj?.formats?.large) {
      arr.push(`${this.getImageURL(imageObj.formats.large.url)} ${imageObj.formats.large.width}w`)
    }
    if (imageObj?.url) {
      arr.push(`${this.getImageURL(imageObj.url)} ${imageObj.width}w`)
    }
    return arr
  }
}
